import Navbar from "../navigation/Navbar";
import { Add, Edit, } from "@mui/icons-material";
import "./EditProfilePage.scss";
import toList from "../utils/ComponentUtil";
import completed from "../../images/user/completed.png";
import profileImg from '../../images/Ellipse_170.png'
import Delete from "../../images/user/delete.png";
import Form from "../utils/Form";
import CustomSelect from "../utils/customSelect";
import CustomTextField from "../utils/CustomTextField";
import DatePicker from "../utils/DatePicker";
import { useState } from "react";
import CustomMultiInput from "../utils/CustomMultiInput";
import ProfileAPI from "../Apis/ProfileAPI";
import history from '../../history';
import { useParams } from "react-router-dom";
import ImageUpload from "../utils/ImageUpload";
import useWindowDimensions from "../utils/WindowDimensions";

function EditProfilePage() {
    const { category } = useParams();
    const categories = ['personal-info', 'experiences', 'education', 'skills', 'certifications', 'portfolios']
    const editProfile = ProfileAPI.getSetting();
    const { width } = useWindowDimensions();
    const isMobile = () => { return width <= 768; }
    const [currentCategory, setCurrentCategory] = useState(categories.indexOf(category));
    const [formValues, setFormValues] = useState(editProfile?.categories?.[currentCategory || 0]?.data || []);
    const addInputTemplate = (values) => {
        let inp = ProfileAPI.profile?.categories?.[currentCategory || 0]?.data?.[0];
        let newObj = {...inp};
        Object.values(newObj).map(i => i.value = undefined);
        formValues.push(newObj);
        setFormValues([...formValues]);
    }
    const [currentSelection, setCurrentSelection] = useState(0);
    const addNew = () => {
        if (formValues.length >= 5) {
            alert('max limit reached');
            return;
        }
        addInputTemplate();
        setCurrentSelection(formValues.length - 1);
    }
    const removedetails = (i) => {
        formValues.splice(i, 1);
        setFormValues([...formValues]);
        setCurrentSelection(formValues.length - 1);
    }
    const goBack = (e) => {
        e.preventDefault();
        let index = currentCategory || 0;
        updateCurrentCategory(index - 1);
    }
    const goNext = () => {
        const len = editProfile?.categories?.length || 1;
        let index = currentCategory || 0;
        while (index + 1 > len && editProfile.categories[index].completed) {
            index += 1;
        }
        updateCurrentCategory(index + 1);
    }
    const saveDetails = (e) => {
        e.preventDefault();
        ProfileAPI.updateSetting(currentCategory, formValues);
        updateCurrentCategory(editProfile?.categories?.length);
    }

    const toClassName = (str) => { return str?.toLowerCase().replaceAll(" ", '-').replaceAll("/", "-"); }
    const getSelectedCategory = () => {
        return editProfile?.categories?.[currentCategory];
    }
    const renderPreview = (item) => {
        return ProfileAPI.profile.categories[currentCategory].renderPreview(item);
    }
    const updateCurrentCategory = (index, len = editProfile?.categories?.length || 1) => {
        history.push(index >= len || index < 0 ? '/profile' : '/setting/' + categories[index]);
        history.go();
    }
    return (
        <>
            <Navbar></Navbar>
            <div className="edit-profile-page-wrp wrapper">
                <div className="details-title-wrp">
                    {
                        toList(editProfile?.categories, undefined, (item, i) =>
                            <div className="title-card" key={i} onClick={(e) => updateCurrentCategory(i)}>
                                <div className="title">{item?.name}</div>
                                {item?.completed && <img className="completed" src={completed} alt="completed" />}
                            </div>
                        )
                    }
                </div>
                <div className="work-experience-wrp">
                    <div className="category-title-wrp">
                        <div className="title">{getSelectedCategory()?.name}</div>
                        {
                            getSelectedCategory()?.multiValue && <div className="add-more-btn-wrp" onClick={addNew}>
                                <div className="add" >Add</div>
                                <Add></Add>
                            </div>
                        }
                    </div>
                    <div className="inputs-wrp">
                        {toList(formValues, undefined, (formvalue , i) => 
                            i === currentSelection && <Form formData={formvalue} dynamic={true} key={i}
                            onSubmit={(e, data) => { 
                                console.log('called')
                                ProfileAPI.updateSetting(currentCategory, formValues); goNext();
                             }}
                            handleInputChange={(e, data) => { return { ...data }; }}
                            render={(data, onChange) =>
                                <>
                                    <div className={"form-inputs-wrp " + toClassName(getSelectedCategory()?.name)}>
                                        {
                                            toList(Object.values(data), undefined, (item, i) =>
                                                <div className={"input-wrp " + toClassName(item.label || item.name)} key={i}>
                                                    <div className="label">{item.label}<span>{item?.required ? '*' : ''}</span></div>
                                                    <div className="input-container">
                                                        {
                                                            item?.type === 'image' ? <ImageUpload inputFile={profileImg} multiple={false} />
                                                                : item?.type === 'date' ? <DatePicker {...item} {...item?.otherProps} parent={item} onChange={onChange} ></DatePicker>
                                                                    : item?.type === 'multiInput' ? <CustomMultiInput {...item} parent={item} onChange={onChange} />
                                                                        : item?.options ? <CustomSelect {...item?.otherProps || {}} {...item} parent={item} onChange={onChange} />
                                                                            : <CustomTextField {...item?.otherProps || {}} {...item} label='' parent={item} onChange={onChange} />
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="selections-wrp">
                                        {
                                            getSelectedCategory()?.multiValue && toList(formValues, undefined, (item, i) =>
                                                <div className="selected-info-wrp" key={i}>
                                                    <div className="work-name">{renderPreview(item) || ''}</div>
                                                    <Edit className="edit-icon" onClick={() => setCurrentSelection(i)} />
                                                    <img className="delete-icon" src={Delete} alt="delete-icon" onClick={() => removedetails(i)} />
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="submit-details-wrp">
                                        {
                                            currentCategory === editProfile?.categories?.length - 1 ? <button className="submit-btn" onClick={(e) => saveDetails(e)}>Submit</button>
                                                : <>
                                                    {currentCategory !== 0 && !(isMobile() && editProfile?.categories[currentCategory].completed) && <button className="back-btn" onClick={(e) => goBack(e)} >Back</button>}
                                                    {editProfile?.categories[currentCategory].completed ? <button className="submit-btn" onClick={(e) => saveDetails(e)} >Submit</button> : <button className="next-btn" >Next</button>}
                                                </>
                                        }
                                    </div>
                                </>
                            }
                        />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditProfilePage;
